interface IMetrics {
  fuelLevel: number | null;
  odometer: {
      updateTime: string;
      value: number;
  };
  tirePressure: Array<{
      updateTime: string;
      value: number;
      vehicleWheel: string;
  }>;
  oilLifeRemaining: {
      updateTime: string;
      value: number;
  };
}

export interface IVehicleDataTMC {
  metrics: IMetrics;
  error: string | null;
}
